import debounce from 'lodash/debounce';
export default {
  props: {
    name: {
      type: String,
      require: true
    },
    title: {
      type: String,
      require: true
    },
    request: {
      type: [Object, Function],
      require: true
    },
    valueName: {
      type: String,
      require: true
    },
    paramName: {
      type: String,
      require: false
    },
    keyName: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      value: null,
      list: [],
      isActive: false
    };
  },
  created() {
    this.showList = debounce(this.showList, 500);
  },
  mounted() {},
  methods: {
    selectDropdownItem(item) {
      this.isActive = false;
      this.value = item.value;
      this.$emit('selectDropdownItem', item, this.name);
    },
    showList() {
      if (!this.value) {
        return;
      }
      this.isActive = true;
      let that = this;
      let params = {
        [this.paramName || this.valueName]: this.value
      };
      this.request(params).then(res => {
        const resData = res.data.data;
        that.list = resData.map(function (e) {
          return {
            id: e[that.keyName],
            value: e[that.valueName]
          };
        });
      }).finally(() => {});
    },
    clearValue() {
      this.value = null;
      this.$emit('clearDropdownItem', this.name);
    }
  }
};